import React from 'react';
import './CemeteryContextBar.css';

/**
 * Sticky banner showing the active cemetery + region/environment.
 * Renders nothing until a cemetery is selected, so pages that
 * mount it unconditionally won't show empty space on first load.
 */
function CemeteryContextBar({ cemeteryName, cemeteryUniqueName, onChange }) {
    if (!cemeteryUniqueName) return null;

    const region = (localStorage.getItem('birt_region') || 'au').toUpperCase();
    const env = (localStorage.getItem('birt_environment') || 'staging').toUpperCase();
    const displayName = cemeteryName || cemeteryUniqueName;

    return (
        <div className="cemetery-context-bar" role="status" aria-live="polite">
            <div className="ccb-left">
                <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                <div className="ccb-name-block">
                    <span className="ccb-label">Working on</span>
                    <strong className="ccb-name" title={cemeteryUniqueName}>{displayName}</strong>
                </div>
            </div>
            <div className="ccb-right">
                <span className={`ccb-badge ccb-badge-region ccb-region-${region.toLowerCase()}`}>{region}</span>
                <span className={`ccb-badge ccb-badge-env ccb-env-${env.toLowerCase()}`}>{env}</span>
                {onChange && (
                    <button className="ccb-change-btn" onClick={onChange} title="Change cemetery">
                        Change
                    </button>
                )}
            </div>
        </div>
    );
}

export default CemeteryContextBar;
